module.exports = __webpack_public_path__ + "img/632c7be069b50341cfd04827f5387bad.png";